export default "__VITE_ASSET__Cu2zx1VQ__"